<template>
	<div>
		
		
		
		<a-modal
		      :title="form.mendian_id > 0 ? '编辑门店' : '新增门店'"
		      :visible="visible"
		      :confirm-loading="confirmLoading"
		      @ok="handleOk"
		      @cancel="handleCancel"
		    >
		      <a-form-model :model="form">
		      	
		      	<a-form-model-item required label="门店名称">
		      		<a-input v-model="form.name" placeholder="输入门店名称" style="width: 300px;"></a-input>
		      	</a-form-model-item>
		      	<a-form-model-item required label="门店电话">
		      		<a-input v-model="form.tel" placeholder="输入门店电话" style="width: 300px;"></a-input>
		      	</a-form-model-item>
		      	
		      	<a-form-model-item required label="门店地址">
		      		<a-input v-model="form.address"  placeholder="输入门店地址" style="width: 300px;"></a-input>
		      	</a-form-model-item>
		      	<a-form-model-item required label="门店定位">
		      		<div class="flex alcenter">
		      			<a-input :value="form.lat + ',' + form.lng" disabled style="width: 200px; margin-right: 10px; color: #000000;"></a-input>
		      			<baidu-map :lat="form.lat" :lng="form.lng" @select="selectAct"></baidu-map>
		      		</div>
		      	</a-form-model-item>
		      	
		      </a-form-model>	
		    </a-modal>
	</div>
</template>

<script>
	import BaiduMap from '../../../../components/map/baidumap.vue';
	export default {
		components:{
			BaiduMap
		},
		props:{
			datas:{
				type:Object,
				default:function(){
					return new Object;
				}
			},
		},
		data(){
			return {
				confirmLoading:false,
				visible:true,
				form:{},
			}
		},
		created(){
			this.form = JSON.parse(JSON.stringify(this.datas));
			this.visible = true;
		},
		methods:{
			selectAct(res){
				this.form.lng = res.lng;
				this.form.lat = res.lat;
			},
			handleOk(){
				if(this.confirmLoading == true) return;
				this.confirmLoading = true;
				this.$http.api('admin/saveMendian',{
					mendian_id:this.form.mendian_id,
					lng:this.form.lng,
					lat:this.form.lat,
					address:this.form.address,
					tel	:this.form.tel,
					name:this.form.name
				}).then(res=>{
					this.$message.success('操作成功');
					this.confirmLoading = false;
					this.visible = false;
					this.$emit('ok');
				}).catch(res=>{
					this.confirmLoading=false;
				})
			},
			handleCancel(){
				this.visible = false;
				this.$emit('closed');
			}
		}
	}
</script>

<style>
	
</style>